import { PassouFalhouEnum } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/enums-consultaSeguimento'
import { calculateResultadoPergunta02 } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/consulta-seguimento/perguntas/consulta-seguimento-pergunta-02/utils-consultaSeguimentoPergunta02'
import { MchatRfAplicacaoQueryModel } from '@atendimento/detail/soap/objetivo/puericultura/mchat-rf/model-mChatRf'

import { HistoricoMChatHeaderTableItem } from '../components/HistoricoMchatHeaderTableItem'
import { HistoricoMChatPerguntaSection } from '../components/HistoricoMchatPerguntaSection'
import { HistoricoMChatResultadoParcialTableItem } from '../components/HistoricoMChatResultadoParcialTableItem'
import { HistoricoMchatTwoColumnsEvenlyTableItem } from '../components/HistoricoMchatTwoColumnsEvenlyTableItem'
import { convertAplicacaoPergunta02 } from './converter-HistoricoMchatPergunta02'

interface HistoricoMChatRfPergunta02Props {
  aplicacoes: ReadonlyArray<MchatRfAplicacaoQueryModel>
}

export const HistoricoMChatRfPergunta02 = (props: Readonly<HistoricoMChatRfPergunta02Props>) => {
  const { aplicacoes } = props

  const converted = convertAplicacaoPergunta02(aplicacoes)
  if (converted === null) return null

  const { ignoraSons, ignoraPessoas, fezExame, resultadoExame, model } = converted
  if (ignoraSons === undefined && ignoraPessoas === undefined) return null

  const resultado = calculateResultadoPergunta02(model)

  const perguntasFirstRow = [ignoraSons, ignoraPessoas].filter((item) => item !== undefined)
  const perguntasLastRow = [fezExame, resultadoExame].filter((item) => item !== undefined)

  return (
    <HistoricoMChatPerguntaSection>
      <HistoricoMChatHeaderTableItem
        numeroPergunta='2'
        title='Você informou que você já se perguntou se o seu filho pode ser surdo. O que o levou a esse pensamento?'
        value={null}
        pergunta='“Ele ou ela...”'
      />
      <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={perguntasFirstRow} />
      <HistoricoMchatTwoColumnsEvenlyTableItem perguntas={perguntasLastRow} />
      {resultado && <HistoricoMChatResultadoParcialTableItem valor={resultado === PassouFalhouEnum.PASSOU} />}
    </HistoricoMChatPerguntaSection>
  )
}
